import script from "./CopyButton.vue?vue&type=script&setup=true&lang=js"
export * from "./CopyButton.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/var/www/html/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"CopyButton.vue"]])

export default __exports__